<ag-grid-angular *ngIf="gridOptions!==undefined" class="ag-theme-balham"
                 [gridOptions]="gridOptions"
                 [rowHeight]="rowHeight"
                 [headerHeight]="headerHeight"
                 (gridReady)="onReadyGrid($event)">
</ag-grid-angular>
